import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
  ReactiveFormsModule,
} from '@angular/forms';

import { CommonModule, NgClass } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute } from '@angular/router';
import { an } from '@fullcalendar/core/internal-common';
import { CommonService } from 'src/app/services/api/common.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-password-reset',
  standalone: true,
  imports: [CommonModule, NgClass, ReactiveFormsModule],
  templateUrl: './password-reset.component.html',
  styleUrl: './password-reset.component.scss',
})
export class PasswordResetComponent {
  resetForm: FormGroup;
  reqs = {
    lowerUpper: false,
    length: false,
    numberOrSymbol: false,
  };
  allRequirementsMet = false;
  emailLink: any;
  showResetPage: any;
  showEmptyState: boolean = true;
  constructor(
    private fb: FormBuilder,
    private ngxService: NgxUiLoaderService,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private toastr: ToastrService
  ) {
    this.resetForm = this.fb.group(
      {
        new_password: ['', [Validators.required]],
        re_enter_password: ['', [Validators.required]],
      },
      { validators: this.passwordsMatch }
    );
    this.ngxService.start();
    this.route.params.subscribe((params) => {
      this.emailLink = params['slugName'];
    });
  }
  ngOnInit(): void {
    this.commonService.resetLinkAuth(this.emailLink).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.status == false) {
          this.toastr.error('The reset link is invalid or has expired.');
          this.showResetPage = false;
          this.showEmptyState = false;
          this.ngxService.stop();
          setTimeout(
            () => {
              window.location.href = '/login';
            }, // 5 seconds
            3000
          );
          // Redirect to login or another appropriate page
          this.ngxService.stop();
        } else if (res.status == true) {
          this.showResetPage = true;
          this.showEmptyState = true;
          this.ngxService.stop();
        }
        // this.overview = res.data.overview.replace(/\n/g, '<br/>')
      },
      error: (err: any) => {
        this.showResetPage = false;
        this.showEmptyState = false;
        this.toastr.error('The reset link is invalid or has expired.');
        this.ngxService.stop();
        setTimeout(
          () => {
            window.location.href = '/login';
          }, // 3 seconds
          3000
        );
        console.log(err);
      },
    });
  }
  checkPasswordRequirements() {
    const pwd = this.resetForm.get('new_password')?.value || '';
    this.reqs.lowerUpper = /[a-z]/.test(pwd) && /[A-Z]/.test(pwd);
    this.reqs.length = pwd.length >= 8;
    // Require both a number and a symbol
    const hasNumber = /\d/.test(pwd);
    const hasSymbol = /[^A-Za-z0-9]/.test(pwd);
    this.reqs.numberOrSymbol = hasNumber && hasSymbol;
    this.allRequirementsMet =
      this.reqs.lowerUpper && this.reqs.length && this.reqs.numberOrSymbol;
  }

  passwordsMatch(group: AbstractControl): ValidationErrors | null {
    const pwd = group.get('new_password')?.value;
    const repwd = group.get('re_enter_password')?.value;
    return pwd === repwd ? null : { passwordMismatch: true };
  }

  resetPassword() {
    this.checkPasswordRequirements();
    if (!this.allRequirementsMet) {
      return;
    }
    if (this.resetForm.invalid) {
      this.resetForm.markAllAsTouched();
      return;
    }
    // Proceed with API call to reset password
    this.ngxService.start();
    const payload = {
      verification_code: this.emailLink,
      new_password: this.resetForm.value.new_password,
      confirm_password: this.resetForm.value.re_enter_password,
    };
    this.commonService.resetPassword(payload).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.status == false) {
          this.ngxService.stop();
          this.toastr.error(
            res.message || 'The reset link is invalid or has expired.'
          );
          this.showResetPage = true;
          this.showEmptyState = true;
          // setTimeout(
          //   () => {
          //     window.location.href = '/login';
          //   }, // 3 seconds
          //   3000
          // );
          // Redirect to login or another appropriate page
          // this.ngxService.stop();
        } else if (res.status == true) {
          this.ngxService.stop();
          this.toastr.success(res.message || 'Password reset successful.');
          setTimeout(
            () => {
              window.location.href = '/login';
            }, // 3 seconds
            3000
          );
        }
        // this.overview = res.data.overview.replace(/\n/g, '<br/>')
      },
      error: (err: any) => {
        this.showResetPage = false;
        this.showEmptyState = false;
        this.toastr.error(err.message || 'An error occurred.');
        setTimeout(
          () => {
            window.location.href = '/login';
          }, // 3 seconds
          3000
        );
        console.log(err);
      },
    });
  }
  
  showPassword = false;
  showPasswordNew = false;

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  togglePasswordNew() {
    this.showPasswordNew = !this.showPasswordNew;
  }
}
